import jwt_decode from 'jwt-decode';
import { store } from '../store';

const getMyPerms = () => {
	const { auth, admins } = store.getState();
	const { adminSSOProfile } = auth;
	return adminSSOProfile && admins[adminSSOProfile.email];
};

export const isSuperAdmin = () => {
	const myPerms = getMyPerms();
	return myPerms && myPerms.is_super;
};

export const isValidClientAdmin = clientID => {
	const myPerms = getMyPerms();
	if (!myPerms) return false;
	if (myPerms.is_super) return true;
	return myPerms.clients.some(client => client.id === parseInt(clientID));
};

export const isValidEventAdmin = event => {
	const myPerms = getMyPerms();
	if (!myPerms) return false;
	if (myPerms.is_super) return true;
	if (event.client_id && isValidClientAdmin(event.client_id)) return true;
	return myPerms.events.some(evt => evt.id === parseInt(event.id));
};

export const hasSomeRoleInEvent = event => {
	const myPerms = getMyPerms();
	if (!myPerms) return false;
	if (myPerms.is_super) return true;
	if (isValidEventAdmin(event)) return true;
	return myPerms.perms.some(perm => perm.event.id === parseInt(event.id));
};

export const isSaaSAdmin = () => {
	const myPerms = getMyPerms();
	if (!myPerms) return true;
	if (myPerms.is_super) return false;
	return myPerms.is_saas;
};

export const tokenInvalidOrExpired = token => {
	try {
		const decodedToken = jwt_decode(token);
		const now = Math.floor(Date.now() / 1000);
		const expAt = decodedToken.exp;
		// console.log(
		// 	`Access Token expires on ${new Date(decodedToken.exp * 1000)}, it is currently ${new Date(
		// 		now * 1000,
		// 	)}`,
		// );
		// console.log(
		// 	`${expAt < now ? 'Access Token is expired. Logging out' : 'Access Token is still valid'}`,
		// );
		return expAt < now;
	} catch (error) {
		return true;
	}
};
